<script setup lang="ts">
import { ref, onErrorCaptured } from 'vue'
import { useI18n } from 'vue-i18n'
import AppIcon from './AppIcon.vue'
import { captureException } from '../../lib/analytics'

const { t } = useI18n()
const hasError = ref(false)
const errorMessage = ref('')

onErrorCaptured((err, _instance, info) => {
  hasError.value = true
  errorMessage.value = err instanceof Error ? err.message : t('errorBoundary.unknown')
  captureException(err, { component: info, url: window.location.href })
  return false
})

function retry() {
  hasError.value = false
  errorMessage.value = ''
}
</script>

<template>
  <slot v-if="!hasError" />
  <div v-else class="flex items-center justify-center min-h-[50vh] p-8">
    <div class="bg-surface-container-lowest rounded shadow-[0_12px_24px_rgba(42,52,57,0.06)] max-w-md w-full p-8 text-center">
      <div class="mx-auto w-12 h-12 rounded-full bg-error-container/30 flex items-center justify-center mb-4">
        <AppIcon name="warning" class="text-error" />
      </div>
      <h2 class="text-lg font-semibold text-on-surface font-display mb-2">{{ t('errorBoundary.title') }}</h2>
      <p class="text-sm text-on-surface-variant mb-6">{{ errorMessage }}</p>
      <button
        @click="retry"
        class="inline-flex items-center px-4 py-2 text-sm font-medium text-on-primary bg-gradient-to-br from-primary to-primary-dim rounded hover:from-primary-dim hover:to-primary-800 transition-colors cursor-pointer"
      >
        {{ t('errorBoundary.retry') }}
      </button>
    </div>
  </div>
</template>
